const isInterfaceHidden = state => state.view.hideInterface === true;

export default isInterfaceHidden;
